@for (history of histories(); track history.revision) {
  <div class="history-item">
    <p>{{ history.versionCreatedAt }}</p>
    @if (history.deltas.length > 0) {
      @for (delta of history.deltas; track delta.field) {
        <p>
          <strong>{{ history.versionCreatedByName ?? history.versionCreatedBy }}</strong> {{ delta.label }}.
        </p>
      }
    }
  </div>
} @empty {
  <div class="loading">
    <visio-loading></visio-loading>
  </div>
}
